<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="学校教师结构"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :cellStyle="style"
      :get-data-func="api.getStructureData"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="现任职年级">
          <el-select v-model="params.NowGradeIds" multiple collapse-tags>
            <template v-for="item in gradeList">
              <el-option :key="item.GradeId" :value="item.GradeId" :label="item.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="职务">
          <el-select v-model="params.JobNames" multiple collapse-tags>
            <template v-for="item in jobList">
              <el-option :key="item.JobId" :value="item.JobName" :label="item.JobName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="科目">
          <el-select v-model="params.Subjects" multiple collapse-tags>
            <template v-for="item in subjectList">
              <el-option :key="item.SubjectId" :value="item.Subject" :label="item.Subject"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Title" />
        <el-table-column prop="TotalCount" label="合计">
          <template slot-scope="{row}">{{row.TotalCount==0?'':row.TotalCount}}</template>
        </el-table-column>
        <el-table-column prop="EduCount0" label="大学专科">
          <template slot-scope="{row}">{{row.EduCount0==0?'':row.EduCount0}}</template>
        </el-table-column>
        <el-table-column prop="EduCount1" label="大学本科">
          <template slot-scope="{row}">{{row.EduCount1==0?'':row.EduCount1}}</template>
        </el-table-column>
        <el-table-column prop="EduCount2" label="硕士研究生" width="90px">
          <template slot-scope="{row}">{{row.EduCount2==0?'':row.EduCount2}}</template>
        </el-table-column>
        <el-table-column prop="EduCount3" label="博士研究生" width="90px">
          <template slot-scope="{row}">{{row.EduCount3==0?'':row.EduCount3}}</template>
        </el-table-column>
        <el-table-column prop="PoliticsCount0" label="党员">
          <template slot-scope="{row}">{{row.PoliticsCount0==0?'':row.PoliticsCount0}}</template>
        </el-table-column>
        <el-table-column prop="PoliticsCount1" label="非党员">
          <template slot-scope="{row}">{{row.PoliticsCount1==0?'':row.PoliticsCount1}}</template>
        </el-table-column>
        <el-table-column prop="PoliticsCount2" label="民主党派">
          <template slot-scope="{row}">{{row.PoliticsCount2==0?'':row.PoliticsCount2}}</template>
        </el-table-column>
        <el-table-column prop="SexCount0" label="男">
          <template slot-scope="{row}">{{row.SexCount0==0?'':row.SexCount0}}</template>
        </el-table-column>
        <el-table-column prop="SexCount1" label="女">
          <template slot-scope="{row}">{{row.SexCount1==0?'':row.SexCount1}}</template>
        </el-table-column>
        <el-table-column prop="AgeCount0" label="30岁以下">
          <template slot-scope="{row}">{{row.AgeCount0==0?'':row.AgeCount0}}</template>
        </el-table-column>
        <el-table-column prop="AgeCount1" label="30-40岁">
          <template slot-scope="{row}">{{row.AgeCount1==0?'':row.AgeCount1}}</template>
        </el-table-column>
        <el-table-column prop="AgeCount2" label="40-50岁">
          <template slot-scope="{row}">{{row.AgeCount2==0?'':row.AgeCount2}}</template>
        </el-table-column>
        <el-table-column prop="AgeCount3" label="50岁以上">
          <template slot-scope="{row}">{{row.AgeCount3==0?'':row.AgeCount3}}</template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {},
  data() {
    return {
      api: require("@/api/gd/common").default,
      gradeApi: require("@/api/ed/grade").default,
      jobApi: require("@/api/ent/job").default,
      subjectApi: require("@/api/ed/subject").default,
      params: {
        Subjects: [],
        JobNames: [],
        NowGradeIds: [],
      },
      gradeList: [],
      subjectList: [],
      jobList: [],
    };
  },
  mounted() {
    this.gradeApi.list({}).then((res) => {
      this.gradeList = res.Data || [];
    });
    this.subjectApi.list({}).then((res) => {
      this.subjectList = res.Data || [];
    });
    this.jobApi.list({}).then((res) => {
      this.jobList = res.Data || [];
    });
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.exportStructureData(params).then((res) => {
        loading.close();
      });
    },
    style: function ({ row, column, rowIndex, columnIndex }) {
      var num = row[column.property];
      if (num == 0) {
        return "background-color: none;";
      } else if (num >= 1 && num <= 2) {
        return "background-color: #ffd5d5;";
      } else if (num >= 3 && num <= 4) {
        return "background-color: #ffcaca;";
      } else if (num >= 5 && num <= 6) {
        return "background-color: #ffb9b9;";
      } else if (num >= 7 && num <= 8) {
        return "background-color: #ff9e9e;";
      } else if (num >= 9 && num <= 10) {
        return "background-color: #ff8787;";
      } else if (num >= 11 && num <= 15) {
        return "background-color: #ff6060;";
      } else if (num >= 16 && num <= 20) {
        return "background-color: #ff4050;";
      } else if (num > 20) {
        return "background-color: #ff0000;";
      } else {
        return "background-color: none;";
      }
    },
  },
};
</script>